import { IStartArcLiveParams } from '@common/interfaces/arcLive'
import Base from './base'

export default class ArcLive extends Base {
  listLiveMeetings() {
    return this.apiClient.get('arc-live/meetings')
  }

  getSession(id: string) {
    return this.apiClient.get(`arc-live/sessions/${id}`)
  }

  requestNote(id: string, chunkId: string) {
    return this.apiClient.post(`arc-live/sessions/${id}/notes`, { chunkId })
  }

  start(data: IStartArcLiveParams) {
    return this.apiClient.post('arc-live/sessions', data)
  }

  stop(id: string) {
    return this.apiClient.post(`arc-live/sessions/${id}/stop`)
  }
}
